/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2020 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * Production environment overrides.
 *
 */

const BASE_URL = 'https://aiadmin-api-pplus.etext-prd.pearsonprd.tech';
const BERLIN_PROD_URI = 'https://berlin-api-pplus.etext-prd.pearsonprd.tech';
const STACKB_PORT = '8443';
const V1_PATH = '/api/v1';
const V2_PATH = '/api/v2.0';
const V3_PATH = '/api/v3.0';

const prod = {
  ENVIRONMENT: 'prod',
  PARTNER_ENV: 'prod',
  BERLIN_ENV: 'prod',
  DELAYED_GTM: false,
  GTM_CONTAINER_ID: 'GTM-WTX7GQN',
  GTM_AUTH: 'ikT7kCxv3rZkV9tHl_-ycA',
  GTM_PREVIEW: 'env-1',
  INT_AZURE_CLIENT_ID: 'f5bd2701-6e7b-4400-b4c1-e72926069b38',
  AZURE_TENANT_ID: '8cc434d7-97d0-47d3-b5c5-14fe0e33e34b',
  INT_BASE_URL: `${BASE_URL}${V1_PATH}`,
  AI_ADMIN_API_BASE_URL: `${BASE_URL}${V1_PATH}`,
  AI_ADMIN_API_BASE_URL_V2: `${BASE_URL}${V2_PATH}`,
  AI_ADMIN_API_BASE_URL_V3: `${BASE_URL}${V3_PATH}`,
  AI_ADMIN_API_BASE_URL_STACKB: `${BASE_URL}:${STACKB_PORT}${V1_PATH}`,
  AI_ADMIN_API_BASE_URL_V2_STACKB: `${BASE_URL}:${STACKB_PORT}${V2_PATH}`,
  AI_ADMIN_API_BASE_URL_V3_STACKB: `${BASE_URL}:${STACKB_PORT}${V3_PATH}`,

  BERLIN_API_URI: 'https://berlin-api-pplus.etext-prd.pearsonprd.tech',
  BERLIN_API_URI_STACKB: `${BERLIN_PROD_URI}:${STACKB_PORT}`,
  MIXPANEL_TOKEN: '9b1ae06574c4ab4cec877b59a7d8de4a'
};

export default prod;
